import React, {Component} from 'react';
import PropTypes from 'prop-types';
import posed, {Transition} from 'react-pose';

import styles from './styles.module.css';

const Status = posed.div({
    show: {
        opacity: 1,
        transition: {
            ease: 'easeOut',
            duration: 700,
        },
        delay: 800,
    },
    hide: {
        opacity: 0,
        transition: {
            ease: 'easeIn',
            duration: 700,
        },
    },
});

class Thinking extends Component {
    static propTypes = {
        hostRef: PropTypes.func.isRequired,
        onDone: PropTypes.func.isRequired,
    };

    state = {
        index: 0,
    };

    statuses = [
        'Counting your chickens…',
        'Flexing adamantium rods…',
        'Reticulating splines…',
        'Finding your hardware…',
        'Testing for compatability…',
    ];

    componentDidMount() {
        const {onDone} = this.props;

        this.rotateText = setInterval(() => {
            const {index} = this.state;

            this.setState({index: index + 1}, () => {
                const {index} = this.state; // eslint-disable-line
                if(index === this.statuses.length) {
                    clearInterval(this.rotateText);
                    this.done = setTimeout(onDone, 1200);
                }
            });
        }, 2500);
    }

    componentWillUnmount() {
        if(this.rotateText)
            clearInterval(this.rotateText);

        if(this.done)
            clearTimeout(this.done);
    }

    render() {
        const {hostRef} = this.props;
        const {index} = this.state;

        return (
            <div ref={hostRef} className={styles.container}>
                <Transition preEnterPose="preEnter">
                    {this.statuses.map((status, idx) => (
                        <Status
                            key={`status${idx}`} // eslint-disable-line
                            index={index}
                            className={styles.status}
                            initialPose="hide"
                            pose={idx === index ? 'show' : 'hide'}
                        >
                            <span>{status}</span>
                        </Status>
                    ))}
                </Transition>
            </div>
        );
    }
}

export default posed(Thinking)({
    preEnter: {
        opacity: 0,
    },
    enter: {
        opacity: 1,
        transition: {
            duration: 0,
        },
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0,
        },
        applyAtEnd: {
            display: 'none',
        },
    },
});
